import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Custom Error Boundary for capturing React errors and logging to CloudWatch
 */
import { Component } from "react";
import logger from "../log";
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return {
            hasError: true,
            error,
        };
    }
    componentDidCatch(error, errorInfo) {
        // Log error details to CloudWatch
        this.logErrorToCloudWatch(error, errorInfo);
        // Update state with error info
        this.setState({
            errorInfo,
        });
        // Call optional error callback
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
    }
    logErrorToCloudWatch(error, errorInfo) {
        // Create comprehensive error log
        const errorDetails = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            componentStack: errorInfo.componentStack,
            timestamp: new Date().toISOString(),
            url: typeof window !== "undefined" ? window.location.href : undefined,
            userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
        };
        // Log error immediately (will be sent to CloudWatch right away due to error level)
        logger.error("React Error Boundary caught error:", errorDetails);
        // Also log to native console for development visibility
        if (process.env.NODE_ENV === "development") {
            console.error("Error caught by ErrorBoundary:", error, errorInfo);
        }
    }
    render() {
        if (this.state.hasError) {
            // Render fallback UI if provided
            if (this.props.fallback) {
                return this.props.fallback;
            }
            // Default fallback UI
            return (_jsxs("div", { role: "alert", style: { padding: "20px", textAlign: "center" }, children: [_jsx("h2", { children: "Something went wrong" }), _jsx("p", { children: "We're sorry, but something unexpected happened. Please try refreshing the page." }), process.env.NODE_ENV === "development" && this.state.error && (_jsxs("details", { style: { marginTop: "20px", textAlign: "left" }, children: [_jsx("summary", { children: "Error Details (Development Only)" }), _jsxs("pre", { style: { whiteSpace: "pre-wrap", wordBreak: "break-word" }, children: [this.state.error.toString(), "\n\n", this.state.error.stack, this.state.errorInfo?.componentStack] })] }))] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
